import { c as _c } from "react/compiler-runtime";
import { Switch as ChakraSwitch } from '@chakra-ui/react';
import { forwardRef } from 'react';
export interface SwitchProps extends ChakraSwitch.RootProps {
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  rootRef?: React.Ref<HTMLLabelElement>;
  trackLabel?: {
    on: React.ReactNode;
    off: React.ReactNode;
  };
  thumbLabel?: {
    on: React.ReactNode;
    off: React.ReactNode;
  };
}
export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(props, ref) {
  const $ = _c(27);
  let children;
  let inputProps;
  let rest;
  let rootRef;
  let thumbLabel;
  let trackLabel;
  if ($[0] !== props) {
    ({
      inputProps,
      children,
      rootRef,
      trackLabel,
      thumbLabel,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = inputProps;
    $[3] = rest;
    $[4] = rootRef;
    $[5] = thumbLabel;
    $[6] = trackLabel;
  } else {
    children = $[1];
    inputProps = $[2];
    rest = $[3];
    rootRef = $[4];
    thumbLabel = $[5];
    trackLabel = $[6];
  }
  let t0;
  if ($[7] !== inputProps || $[8] !== ref) {
    t0 = <ChakraSwitch.HiddenInput ref={ref} {...inputProps} />;
    $[7] = inputProps;
    $[8] = ref;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  let t1;
  if ($[10] !== thumbLabel) {
    t1 = thumbLabel && <ChakraSwitch.ThumbIndicator fallback={thumbLabel?.off}>{thumbLabel?.on}</ChakraSwitch.ThumbIndicator>;
    $[10] = thumbLabel;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== t1) {
    t2 = <ChakraSwitch.Thumb>{t1}</ChakraSwitch.Thumb>;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== trackLabel) {
    t3 = trackLabel && <ChakraSwitch.Indicator fallback={trackLabel.off}>{trackLabel.on}</ChakraSwitch.Indicator>;
    $[14] = trackLabel;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = <ChakraSwitch.Control>{t2}{t3}</ChakraSwitch.Control>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== children) {
    t5 = children != null && <ChakraSwitch.Label>{children}</ChakraSwitch.Label>;
    $[19] = children;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== rest || $[22] !== rootRef || $[23] !== t0 || $[24] !== t4 || $[25] !== t5) {
    t6 = <ChakraSwitch.Root ref={rootRef} {...rest}>{t0}{t4}{t5}</ChakraSwitch.Root>;
    $[21] = rest;
    $[22] = rootRef;
    $[23] = t0;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
});